import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input} from 'react-bootstrap'
import {checkboxField} from '../../core/redux/form'
import Card from '../../core/components/Card'
import Markdown from '../../core/components/Markdown'
import i18n from '../i18n'
import OpeningTicketPurposePicker from '../../reference/components/OpeningTicketPurposePicker'
import {queryOpeningTicketInstructionStream} from '../../message/actions'
import {updateOpenTicketCmd} from '../actions'
import style from './OpenTicketPurposeCard.less'

class OpenTicketPurposeCard extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        form: PropTypes.func.isRequired,
        cmd: PropTypes.object
    }

    componentWillMount() {
        const {dispatch, cmd} = this.props

        if (cmd && cmd.company && cmd.ticket && cmd.ticket.openingTicketPurpose) {
            const company = cmd.company
            const openingTicketPurpose = cmd.ticket.openingTicketPurpose

            const query = {
                openingTicketPurpose: openingTicketPurpose.uid
            }
            dispatch(queryOpeningTicketInstructionStream(company, query))
        }
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.cmd && nextProps.cmd.company != (this.props.cmd && this.props.cmd.company))
            || (nextProps.cmd && nextProps.cmd.ticket && nextProps.cmd.ticket.openingTicketPurpose != (this.props.cmd && this.props.cmd.ticket && this.props.cmd.ticket.openingTicketPurpose))) {
            const {dispatch, cmd} = nextProps

            if (cmd && cmd.company && cmd.ticket && cmd.ticket.openingTicketPurpose) {
                const company = cmd.company
                const openingTicketPurpose = cmd.ticket.openingTicketPurpose

                const query = {
                    openingTicketPurpose: openingTicketPurpose.uid
                }
                dispatch(queryOpeningTicketInstructionStream(company, query))
            }
        }
        if (nextProps.openingTicketInstructionStream != this.props.openingTicketInstructionStream) {
            const {dispatch, openingTicketInstructionStream} = nextProps

            var acknowledgeInstruction = null
            if (openingTicketInstructionStream.length > 0) {
                acknowledgeInstruction = false
            }
            dispatch(updateOpenTicketCmd({acknowledgeInstruction}))
        }
    }

    render() {
        const {dispatch, form, cmd, openingTicketInstructionStream, ...others} = this.props

        const header = (
            <h5>{i18n.diagnostic}</h5>
        )

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        return (
            <Card
                header={header}
                {...others}>
                {cmd && cmd.company && (
                    <OpeningTicketPurposePicker
                        company={cmd.company}
                        onQualificationChange={e => dispatch(updateOpenTicketCmd(e))}
                        {...form.ticket.openingTicketPurpose()}>
                        {openingTicketInstructionStream.length > 0 && (
                            <div className={style.openingTicketInstruction}>
                                <h5>{i18n.openingTicketInstruction}</h5>
                                <Markdown markdown={openingTicketInstructionStream[0].text} />
                                <Input
                                    type='checkbox'
                                    label={requiredLabel(i18n.acknowledgeInstruction)}
                                    {...checkboxField(form.acknowledgeInstruction())}/>
                            </div>
                        )}
                        {openingTicketInstructionStream.length == 0 && (
                            <span />
                        )}
                    </OpeningTicketPurposePicker>
                )}
            </Card>
        )
    }
}

OpenTicketPurposeCard = connect((state) => ({
    openingTicketInstructionStream: state.message.openingTicketInstruction.stream
}))(OpenTicketPurposeCard)

export default OpenTicketPurposeCard


// WEBPACK FOOTER //
// ./lib/ticket/components/OpenTicketPurposeCard.js